import translations from './en.json';

export default translations;
